<template>
    <v-container fluid class="pa-0">
        <v-layout row fill-height wrap>
            <v-flex sm12 md5 id="form">
                <h3 id="form-title" class="font-weight-bold">
                    Portal de Recepción de Facturas
                </h3>

                <div id="login-form" v-if="!showRecoverPassword && !token">
                    <h3 class="font-weight-light mb-2">
                        Bienvenido
                    </h3>
                    <div class="subtext mb-5">
                        Ingresa tu usuario y contraseña para continuar
                    </div>
                    <div class="stretch text-xs-center">
                        <v-text-field class="lance"
                            ref="username"
                            autofocus
                            label="Usuario"
                            v-model="model.username">
                        </v-text-field>
                        <v-text-field class="lance no-right-padding"
                            type="password"
                            label="Contraseña"
                            v-model="model.password"
                            @keyup.enter.native="login()">
                            <template slot="append">
                                <div class="btn-login" @click="login()">
                                    <v-icon size="40px" dark>input</v-icon>
                                </div>
                            </template>
                        </v-text-field>
                        <a @click="showRecoverPassword = true">
                            ¿Olvidaste tu contraseña?
                        </a>
                    </div>
                </div>

                <div id="send-recover-password-form" v-if="showRecoverPassword">
                    <h3 class="font-weight-light mb-2">
                        Cambio de contraseña
                    </h3>
                    <div class="subtext mb-5">
                        Ingresa tu correo electrónico para recibir tu enlace
                    </div>
                    <div class="stretch text-xs-center">
                        <v-form v-model="valid" action="javascript:void(0)">
                            <v-text-field class="lance no-right-padding"
                                type="text"
                                label="Correo Electrónico"
                                v-model="email"
                                :rules="[
                                    v => !!v || 'Campo Requerido', 
                                    v => !!v.match(/@whirlpool.com/) || !!v.match(/@ltmexico.net/) || !!v.match(/@moviro.mx/) || 'El correo no es válido'
                                    ]"
                                @keyup.enter.native="sendRecoveryEmail()">
                                <template slot="append">
                                    <v-btn id="sendRecoveryEmailBtn"
                                        class="btn-login"
                                        color="submitBtn"
                                        depressed
                                        min-width="75px"
                                        :loading="loading"
                                        @click="sendRecoveryEmail()">
                                        <v-icon size="40px" dark>input</v-icon>
                                    </v-btn>
                                </template>
                            </v-text-field>
                        </v-form>
                        <a @click="showRecoverPassword = false">
                            Regresar a login
                        </a>
                    </div>
                </div>

                <div id="recover-password-form" v-if="token">
                    <h3 class="font-weight-light mb-2">Recuperación de contraseña</h3>
                    <div class="subtext mb-5">Ingresa tu nueva contraseña</div>
                    <div class="stretch text-xs-center">
                        <v-form v-model="valid" action="javascript:void(0)">    
                            <v-text-field class="lance"
                                v-model="model.newPassword"
                                label="Nueva Contraseña"
                                type="password"
                                :rules="[v => !!v || 'Campo requerido']">
                            </v-text-field>
                            <v-text-field class="lance no-right-padding"
                                v-model="model.confirmPassword"
                                label="Confirmar Contraseña"
                                type="password"
                                :rules="[
                                    v => !!v || 'Campo requerido', 
                                    v => v === model.newPassword || 'Contraseña no coincide'
                                ]"
                                @keyup.enter.native="resetPassword()">
                                <template slot="append">
                                    <div class="btn-login" @click="resetPassword()">
                                        <v-icon size="40px" dark>input</v-icon>
                                    </div>
                                </template>
                            </v-text-field>
                        </v-form>
                        <br>
                    </div>
                </div>
            </v-flex>

            <v-flex sm12 md7 id="landing">
                <div id="fondo">
                    <h3 class="landing-text">
                        Making the Most of Moments that Matter
                    </h3>
                    <img src="./../assets/landing.jpg">
                </div>
                <div id="version" v-if="version">
                    v{{version}}
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { events } from '../main';
export default {
    name: 'login',
    data () {
        return {
            model: {
                username: '',
                password: ''
            },
            valid: false,
            version: null,
            email: "",
            token: null,
            tries: 1,
            triedUsername: "",
            showRecoverPassword: false,
            loading: false,
        }
    },
    methods: {
        login() {
            if (!this.model.username || !this.model.password) {
                this.snackbar("Favor de llenar todos los campos");
                return;
            }
            if (this.triedUsername == this.model.username) {
                this.tries++;
            } else {
                this.tries = 1;
                this.triedUsername = this.model.username;
            }
            this.model.block = this.tries >= 3;
            this.$http.post('login', this.model)
                .then(response => {
                    localStorage.setItem("userId", response.body.userId);
                    localStorage.setItem("userToken", response.body.token);
                    localStorage.setItem("userCredentials", response.body.credentials);
                    const redirectUrl = this.$route.query.redirect;
                    redirectUrl ? this.$router.push(redirectUrl) : this.$router.push('/');
                }, error => {
                    this.snackbar(error.body.msg || 'Usuario o Contraseña incorrectos.');
                    this.model = {
                        username: '',
                        password: ''
                    }
                    this.$refs.username.focus();
                });
        },
        sendRecoveryEmail() {
            if (!this.valid) {
                this.snackbar("El email no es valido");
                return;
            }
            this.loading = true;
            this.$http.post("login/recoverpassword", {email: this.email, isNewUser: false}).then(
                result => {
                    this.snackbar("Se ha enviado el correo exitosamente.");
                    this.email= "";
                    this.showRecoverPassword = false;
                },
                error => {
                    this.snackbar(error.body.msg || "No se ha podido enviar el correo de recuperación");
                }
            ).finally( () => {
                this.loading = false;
            });
        },
        /*************************       Recover Password Funcions       *************************/
        validateToken() {
            this.$http.post(`login/validatetoken/${this.token}`).then(response => {}).catch( error => {
                this.snackbar("El link es invalido.");
                this.$router.push("/login");
                this.token = null;
            });
        },
        resetPassword() {
            if (!this.valid) {
                this.snackbar("La contraseña no es valida");
                return;
            }
            this.$http.put("login/recoverpassword/" + this.token, {newPassword: this.model.newPassword})
            .then(response => {
                this.snackbar("Su contraseña ha sido cambiada.")
                this.$router.push("/");
            }).catch(error => {
                this.snackbar(error.body.msg || "No se pudo actualizar la contraseña");
            });
        },
        snackbar(message){
            events.$emit('snackbar', message);
        }
    },
    mounted() {
        this.$http.get("app/version").then(
            result => {
                this.version = result.body.version;
            },
            error => {
                this.snackbar(error.body.msg || "No se pudo obtener la version");
            }
        );
        this.token = this.$route.params.token;
        if (this.token) {
            this.title = "Recuperar Contraseña";
            this.validateToken();
        }
    },
    directives: {
        focus: {
            inserted: function (el) {
            el.focus()
            }
        }
    }
}
</script>

<style scoped>
    #form {
        padding-left: 110px;
        background-color: #f6f6f6;
        color: #707070;
        z-index: 1;
    }

    #form #form-title {
        margin-top: 150px;
        margin-bottom: 100px;
        margin-right: 110px;
        max-width: 390px;
    }

    #form .subtext {
        font-size: 18px;
    }

    #form .stretch {
        width: calc(100% + 75px);
    }

    #form .v-text-field >>> .v-input__slot {
        height: 75px;
        border-radius: 100px !important;
        padding-left: 80px;
        padding-right: 0;
    }
    #form a {
        display: inline-block;
        margin-bottom: 60px;
    }

    .btn-login, #sendRecoveryEmailBtn {
        margin: 0;
        padding-left: 0;
        height: 75px;
        width: 75px;
        min-width: 0;
        padding-right: 10px;
        border-top-right-radius: 100px;
        border-bottom-right-radius: 100px;
        background-color: var(--v-submitBtn-base);
        color: white;
        display: flex;
        justify-content: center;
        cursor: pointer;
    }

    #landing {
        background-image: linear-gradient(to top right, #E8E8E8, #75787B);
        z-index: 0;
        
    }
    #landing #fondo {
        background-image: url("../assets/fondo2.svg");
        background-position-y: bottom;
        background-size: contain;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;      
    }
    #landing .landing-text {
        color: white;
        font-size: 40px;
        text-align: center;
    }
    #landing h3 {
        margin-bottom: 20px;
    }
    #landing img {
        width: 100%;
    }
    #version {
        position: absolute;
        bottom: 4px;
        right: 10px;
    }

    @media screen and (max-width: 959px){
        #form {
            padding-left: 30px;
            padding-right: 30px;
        }
        #form #form-title {
            margin-top: 50px;
            margin-bottom: 50px;
        }
        #form .stretch {
            width: 100%;
        }

        #landing h3 {
            margin-top: 75px;
        }
        #landing img {
            margin-bottom: 200px;
        }
    }
</style>

